var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tab-container small base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c(
          "ul",
          { staticClass: "head" },
          _vm._l(_vm.tableState, function(status) {
            return _c(
              "li",
              {
                staticClass: "head-item",
                class: { current: status.value == _vm.checkStateValue },
                on: {
                  click: function($event) {
                    _vm.handleTabClick(status.value)
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(status.text))])]
            )
          })
        )
      ])
    ]),
    _vm._v(" "),
    _vm.checkStateValue === 0
      ? _c(
          "div",
          [
            _c("swb-merchant-biz-param-list", {
              attrs: { groupCodeList: _vm.groupCodeList }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("swb-org-biz-param-list", {
              attrs: { channelCode: "bizParamRepair" }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48fa972b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48fa972b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizParam/BizParamListForDispatch.vue
// module id = 2802
// module chunks = 1